import APIController from '../core-api-controller';

export const fetchFollowUpsApi = (paramsObj = {}, paramsStr = '') => {
  const path = `${APIController.endpointApi}/follow_ups${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const fetchFollowUpApi = (id = '') => {
  const path = `${APIController.endpointApi}/follow_ups/${id}`;
  return APIController.getApiCallback(path);
};

export const markFollowUpCompleteApi = (id = '') => {
  const path = `${APIController.endpointApi}/follow_ups/${id}/mark_as_complete`;
  return APIController.putCallback(path);
};

export const updateFollowUpsApi = (id = '', data = {}) => {
  const path = `${APIController.endpointApi}/follow_ups/${id}`;
  return APIController.putCallback(path, data);
};

export const createFollowUpsApi = (data = {}) => {
  const path = `${APIController.endpointApi}/follow_ups`;
  return APIController.postCallback(path, data);
};
